import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CONTACT = {
    firm: "Ford & Associates",
    addressLines: ["17665 Leslie Street, Unit 35", "Newmarket, Ontario", "L3Y 3E3"],
    phoneDisplay: "289-464-1001",
    phoneHref: "tel:+12894641001",
    email: "info@fordassociates.ca",
    website: "fordassociates.ca",
    hours: [
        { days: "Tuesday – Thursday", time: "9:00 AM – 5:00 PM" },
        { days: "Monday & Friday", time: "By appointment" },
    ],
    directionsUrl:
        "https://www.google.com/maps/dir/?api=1&destination=17665+Leslie+Street+Unit+35+Newmarket+ON+L3Y+3E3",
    mapEmbed:
        "https://maps.google.com/maps?q=17665%20Leslie%20Street%20Unit%2035%20Newmarket%20Ontario&z=14&output=embed",
};

export const APPS = {
    clientManager: {
        name: "Client Manager",
        tagline: "Client portal & account access",
        description: "Secure access to your Ford & Associates client account and client services.",
        url: "https://clientmgr.app",
        host: "clientmgr.app",
    },
    taxManager: {
        name: "Tax Manager",
        tagline: "Personal tax return portal",
        description: "Secure personal tax return portal for T1 clients.",
        url: "https://taxmanager.pro",
        host: "taxmanager.pro",
    },
};

export const SERVICES = [
    {
        num: "01",
        title: "Personal Tax",
        short: "Professional preparation of Canadian personal income tax returns — including complex situations, families, investments and self-employed taxpayers.",
        icon: "FileUser",
        details: [
            "T1 personal returns — simple to complex",
            "Self-employed, commission and multi-source income",
            "Families, dependants, investments & rental property",
            "Estates and trust returns",
            "Prior-year adjustments and voluntary corrections",
        ],
    },
    {
        num: "02",
        title: "Corporate & Business Tax",
        short: "Corporate income tax preparation, year-end tax compliance, planning and support for incorporated businesses.",
        icon: "Building2",
        details: [
            "T2 corporate income tax preparation",
            "Year-end tax compliance and filings",
            "Corporate tax planning and instalment guidance",
            "Compensation strategy — salary vs. dividends",
            "Support through CRA corporate reviews",
        ],
    },
    {
        num: "03",
        title: "Accounting",
        short: "Financial reporting, accounting assistance, financial statement preparation and organization of your business financial records.",
        icon: "BookOpenCheck",
        details: [
            "Financial statement preparation",
            "Bookkeeping organization and review",
            "Budgeting and management reporting",
            "Clear insight into your financial position",
            "Records maintained to professional standards",
        ],
    },
    {
        num: "04",
        title: "Small Business Services",
        short: "Support for entrepreneurs, the self-employed and growing businesses — tax compliance, GST/HST, payroll matters and ongoing financial guidance.",
        icon: "Store",
        details: [
            "GST/HST registration, filing and remittance",
            "Payroll-related matters and deductions",
            "Sole proprietor, partnership and incorporated support",
            "Quarterly filings and year-end planning",
            "Year-round compliance guidance",
        ],
    },
    {
        num: "05",
        title: "CRA Representation",
        short: "Professional assistance with the Canada Revenue Agency — reviews, audits, information requests and resolving tax matters.",
        icon: "ShieldCheck",
        details: [
            "Responding to CRA reviews and audits",
            "Information and document requests",
            "Communicating with CRA on your behalf",
            "Resolving disputed or outstanding matters",
            "Protecting your interests and your rights",
        ],
    },
    {
        num: "06",
        title: "Business Advisory",
        short: "Strategic financial and business guidance — structure, cash flow, growth, transition and planning for the decisions ahead.",
        icon: "Compass",
        page: "/business-advisory",
        details: [
            "Business structure and organization advice",
            "Cash flow management and forecasting",
            "Growth and transition planning",
            "Financial analysis for informed decisions",
            "Practical, tailored solutions",
        ],
    },
];

export const TESTIMONIALS = [
    {
        name: "Ford & Associates Client",
        tag: "Overall Experience",
        text: "Honestly, the entire experience was exceptional. Perfectly professional, highly skilled, with excellent communication. Truthfully, it was perfect. I am so grateful I found you.",
    },
    {
        name: "Colleen J.",
        tag: "Personal Tax",
        text: "Michael is very professional and always very nice. He is knowledgeable and efficient, and he makes tax season easy for us.",
    },
    {
        name: "Ford & Associates Client",
        tag: "Communication & Support",
        text: "The communication and support were excellent! Whenever we had a question or needed help, we received a response very quickly. Overall, it was an excellent experience. We are very grateful.",
    },
    {
        name: "Mark K.",
        tag: "Value & Referrals",
        text: "I love the value, service and professionalism. I referred my mom as well, and she is also very happy.",
    },
    {
        name: "Demonna R.",
        tag: "Long-Term Trust",
        text: "I have been coming to Michael for over ten years and have always found him very approachable and helpful. He has helped me and members of my family and is always available for our questions. I would recommend this company to anyone looking for an honest and dependable firm for income tax services.",
    },
    {
        name: "Ford & Associates Client",
        tag: "Communication & Expertise",
        text: "I appreciated the communication and the time taken to clearly explain the issues regarding my file. Both my business and personal returns were completed and filed well before April 30. Don't you just wish every business experience could be this positive!",
    },
    {
        name: "Small Business Client",
        tag: "Small Business Support",
        text: "I don't feel like just a number. A small to medium-sized firm still values a small business like mine and treats me like any other client.",
    },
    {
        name: "Andrew S.",
        tag: "Value & Professionalism",
        text: "Good communication, everyone is very friendly and professional, and the pricing is very reasonable considering what I submitted.",
    },
    {
        name: "Nancy E.",
        tag: "Long-Term Trust",
        text: "I am a long-time client of Michael Ford and very happy with the services I have received over the years.",
    },
    {
        name: "Nancy E.",
        tag: "Clear Explanations",
        text: "I very much appreciated Michael calling me about a question I had regarding income splitting. He was able to explain in detail how it affected our tax returns.",
    },
    {
        name: "Theresa M.",
        tag: "Overall Experience",
        text: "Best decision I ever made coming to Ford & Associates.",
    },
    {
        name: "Mark K.",
        tag: "Recommendation",
        text: "I was so happy and impressed that I will be recommending you to everyone.",
    },
    {
        name: "Sam A.",
        tag: "Professionalism",
        text: "Professional, organized and very friendly.",
    },
    {
        name: "Shirley S.",
        tag: "Service Experience",
        text: "Very prompt service, a professional package, and friendly associates.",
    },
    {
        name: "Susan D.",
        tag: "Responsiveness",
        text: "Very quick and thorough responses from your office.",
    },
    {
        name: "Linda J.",
        tag: "Clear Explanations",
        text: "You answered our questions and made sure that we understood.",
    },
    {
        name: "Ford & Associates Client",
        tag: "Clear Explanations",
        text: "I did not have a clue, and Michael was a great help explaining everything to me. I was very pleased.",
    },
    {
        name: "Debbie D.",
        tag: "Professionalism & Trust",
        text: "Very professional and answered all of my questions. I have been dealing with Michael Ford for many years and I am very pleased.",
    },
    {
        name: "Janice S.",
        tag: "Speed & Accuracy",
        text: "Fast, efficient and accurate!",
    },
    {
        name: "Mark J.",
        tag: "Overall Experience",
        text: "Excellent job. Easy to deal with. Terrific experience.",
    },
];

export const RESOURCES = [
    {
        name: "CRA My Account",
        desc: "Sign in or register for My Account, My Business Account, or Represent a Client.",
        url: "https://www.canada.ca/en/revenue-agency/services/e-services/cra-login-services.html",
    },
    {
        name: "CRA My Business Account",
        desc: "Access business-related CRA services for employers, corporations and partnerships.",
        url: "https://www.canada.ca/en/revenue-agency/services/e-services/e-services-businesses/business-account.html",
    },
    {
        name: "Income Tax",
        desc: "Personal, business, corporation, trust and international income tax information.",
        url: "https://www.canada.ca/en/services/taxes/income-tax.html",
    },
    {
        name: "CRA Payments",
        desc: "Ways to send payments to the CRA — and what to do if you can't pay on time.",
        url: "https://www.canada.ca/en/revenue-agency/services/payments.html",
    },
    {
        name: "Tax Credits & Benefits",
        desc: "Benefit programs, eligibility and application instructions for individuals and families.",
        url: "https://www.canada.ca/en/services/taxes/child-and-family-benefits.html",
    },
    {
        name: "GST/HST",
        desc: "Charge, remit and report the Goods and Services Tax / Harmonized Sales Tax.",
        url: "https://www.canada.ca/en/revenue-agency/services/tax/businesses/topics/gst-hst-businesses.html",
    },
    {
        name: "Payroll",
        desc: "Calculate deductions, open a payroll account and report employee income.",
        url: "https://www.canada.ca/en/revenue-agency/services/tax/businesses/topics/payroll.html",
    },
    {
        name: "Business Number",
        desc: "Your federal business number and CRA program accounts.",
        url: "https://www.canada.ca/en/services/taxes/business-number.html",
    },
    {
        name: "Charities",
        desc: "Charity listings, registration and charitable tax credits.",
        url: "https://www.canada.ca/en/services/taxes/charities.html",
    },
    {
        name: "Savings & Pension Plans",
        desc: "Registered plans for individuals and plan administrators.",
        url: "https://www.canada.ca/en/services/taxes/savings-and-pension-plans.html",
    },
];

export const FALLBACK_ARTICLES = [
    {
        slug: "how-to-make-next-tax-season-easy",
        category: "Tax Center",
        title: "How to Make Next Tax Season Easy",
        date_display: "July 31, 2026",
        excerpt: "Five practical habits — organized documents, technology, professional advice, planning ahead and staying informed — that make tax season stress-free.",
        image: "https://images.unsplash.com/photo-1714974528737-3e6c7e4d11af?q=80&w=1600&auto=format&fit=crop",
    },
    {
        slug: "why-your-bookkeeping-is-costing-you-money",
        category: "Business Advisory",
        title: "Why Your Bookkeeping is Costing You Money",
        date_display: "July 24, 2026",
        excerpt: "Neglecting proper bookkeeping leads to overpaid taxes, missed deductions and costly catch-up work — why accurate records pay for themselves.",
        image: "https://images.unsplash.com/photo-1624555130581-1d9cca783bc0?q=80&w=1600&auto=format&fit=crop",
    },
    {
        slug: "the-write-offs-youre-probably-missing",
        category: "Tax Center",
        title: "The Write-Offs You're Probably Missing",
        date_display: "July 17, 2026",
        excerpt: "From home office expenses to vehicle logs — ten commonly missed deductions Canadian business owners should review before filing.",
        image: "https://images.unsplash.com/photo-1551836022-4c4c79ecde51?q=80&w=1600&auto=format&fit=crop",
    },
];

export const FALLBACK_TAX_SEASON = {
    status: "Open",
    status_tone: "open",
    headline: "Tax season is open. Book your appointment, or upload documents securely through Tax Manager.",
    dates: [
        ["T1 filing deadline — most individuals", "April 30, 2026"],
        ["T1 filing deadline — self-employed & spouses", "June 15, 2026"],
        ["Balance-owing payment deadline", "April 30, 2026"],
    ],
    notices: [
        "Appointments available by phone, video, or in person at our Newmarket office.",
        "Send your documents through Tax Manager at any time — we will confirm receipt within one business day.",
    ],
    instructions: "To get started: upload your slips and documents to Tax Manager, complete any questionnaire we send you, and sign forms electronically. Everything is handled in one secure place.",
};

export const MANIFESTO = [
    {
        num: "01",
        title: "Experience",
        text: "Established accounting and tax practice serving individuals, families, incorporated businesses, entrepreneurs, estates and trusts across Ontario.",
    },
    {
        num: "02",
        title: "Personal service",
        text: "You work with a person, not a queue. Meetings are unhurried, questions are answered patiently, and your file is handled by someone who knows it.",
    },
    {
        num: "03",
        title: "Practical advice",
        text: "We simplify taxation, compliance and financial decision-making — clear guidance you can act on, without the jargon.",
    },
    {
        num: "04",
        title: "Technology",
        text: "Secure client portals, digital document exchange and electronic signatures — modern tools that respect your time, in the office and during tax season.",
    },
    {
        num: "05",
        title: "Long-term relationships",
        text: "Most of our clients arrive by referral and stay for decades. We plan beyond this year's filing, for what comes next.",
    },
];
